<template>
  <div>
    <el-tabs v-model="activeName" @tab-click="handleChange">
      <el-tab-pane
        v-for="tab in tabs"
        :label="tab.label"
        :name="tab.value"
        :key="tab.value"
      />
    </el-tabs>
    <!-- eslint-disable-next-line vue/no-unused-refs -->
    <base-list-management
      ref="baseListManagement"
      :configData.sync="configData"
    />
  </div>
</template>

<script>
import config from '../config/approveCenterListConfig'
import mixin from '../../mixins/taskCenter'
import approvalCommon from '../../mixins/approvalCommon'
import { mapGetters } from 'vuex'

const { tabs } = config
export default {
  name: 'taskCenter',
  mixins: [mixin, approvalCommon],
  data() {
    return {
      activeName: 'self',
      tabs, // 审批中心切换tab
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
  },
  methods: {
    // 切换tab
    handleChange() {
      this.m_getApprovalTaskList()
    },
    // 处理搜索数据
    // eslint-disable-next-line vue/no-unused-properties
    dealWithSearch(val) {
      const params = this.m_dealWithSearch(val)
      params.originatorId = this.userInfo.id
      return params
    },
  },
}
</script>
